<div class="column-container">
  <div class="title" i18n>購買數量</div>

  <div class="stepper center-container">
    <button class="minus-btn center-container" appFocusRemove
            [class.disabled]="value() <= data.min"
            (click)="decrease()">
      <app-image-loading src="assets/icon_minus.svg" alt="減少" i18n-alt
                         [clickable]="true"
                         [targetWidth]="13"
                         [targetHeight]="13"
                         [class.disabled-img]="value() <= data.min"/>
    </button>
    <input class="count" maxlength="2"
           [value]="value()"
           (change)="onNumberChange($any($event.target).value, $any($event.target))"/>
    <button class="plus-btn center-container" appFocusRemove
            [class.disabled]="value() >= data.max"
            (click)="increase()">
      <app-image-loading src="assets/icon_plus.svg" alt="增加" i18n-alt
                         [clickable]="true"
                         [targetWidth]="13"
                         [targetHeight]="13"
                         [class.disabled-img]="value() >= data.max"/>
    </button>
  </div>
  <div class="submit-button-container">
    <button type="button" appFocusRemove mat-dialog-close i18n>取消</button>
    <button type="button" (click)="onClose()" appFocusRemove i18n>確定</button>
  </div>
</div>
